

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";



const rewardEarnAtom = atom({key:'rewardEarn_atom', default:{reward_info:[],reward_type_info:[]}
});


export  const SetRewardHistoryStoreList= () => useSetRecoilState(rewardEarnAtom);
export  const GetRewardHistoryStoreList = () => useRecoilValue(rewardEarnAtom);







